import { isAndroid, isiOS, isMacOS } from './userAgentHelper';

const normalizeKeyName = (keyName) => {
    if (isAndroid()) {
        return keyName;
    } else if (isiOS() || isMacOS()) {
        switch (keyName) {
            case 'Ctrl':
                return 'Cmd';
            case 'CTRL':
                return 'CMD';
            default:
                return keyName;
        }
    } else {
        return keyName;
    }
};

export { isAndroid, isiOS, isMacOS, normalizeKeyName };
